/**
 * Preferencias de pantalla guardadas en el navegador.
 *
 * La lógica es corta pero lo difícil ya está resuelto acá: `localStorage` **tira** en modo privado
 * y con la cuota llena, y una preferencia de presentación nunca puede romper la pantalla que
 * decora. Por eso todo va con guarda y todo degrada al default.
 *
 * Salió de `ColumnSelector`, que la tenía atada a columnas; el selector de eventos de auditoría
 * necesitaba lo mismo. El prefijo se mantiene igual (`boveda.` + la clave completa) para que
 * `columns.doctree` siga resolviendo a `boveda.columns.doctree` y **nadie pierda la elección de
 * columnas que ya tenía**.
 *
 * Pendiente conocido (#159): la clave es por navegador y no por usuario, así que en una estación
 * compartida la elección del anterior persiste para el siguiente.
 */
const PREFIJO = 'boveda.';

export const cargarPrefs = (clave, porDefecto = {}) => {
  if (!clave) return porDefecto;
  try {
    const crudo = localStorage.getItem(PREFIJO + clave);
    if (crudo === null) return porDefecto;
    const parsed = JSON.parse(crudo);
    return parsed !== null && typeof parsed === 'object' ? parsed : porDefecto;
  } catch {
    return porDefecto;
  }
};

export const guardarPrefs = (clave, valor) => {
  if (!clave) return;
  try {
    localStorage.setItem(PREFIJO + clave, JSON.stringify(valor));
  } catch {
    // cuota llena, modo privado: la preferencia se pierde, la pantalla sigue andando
  }
};

/**
 * Igual que `cargarPrefs` pero para listas. Existe porque el consumidor que espera un array se
 * rompe en el render si le llega un objeto —`new Set({})` y `.includes` tiran TypeError—, y como
 * el control para arreglarlo vive dentro de la pantalla que ya no se pinta, el usuario queda sin
 * forma de recuperarse: hay que borrarle el `localStorage` a mano. Un valor con la forma
 * equivocada tiene que degradar al default, igual que uno corrupto.
 */
export const cargarLista = (clave, porDefecto = []) => {
  const valor = cargarPrefs(clave, porDefecto);
  return Array.isArray(valor) ? valor : porDefecto;
};
